import { ITeplarListVM } from '../../models/response/ITeplarResponse';
const initialTeplarState: ITeplarListVM = {
  PagingDetails: {
    TotalRecords: 1,
    TotalPages: 1,
    CurrentPage: 1,
    PageSize: 10,
  },
  Teplars: [],
  MaxItem: 0,
};

export default initialTeplarState;
